export default __webpack_public_path__ + "static/media/opengptnews.d0ff678e.png";